import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { pushLocation } from 'src/resources/location/reducer';
import { RootStoreType } from 'src/types/store';

const Location: FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const locationHistory = useSelector((state: RootStoreType) => state.location.history);

    useEffect(() => {
        if (!locationHistory[0] || locationHistory[0].pathname != location.pathname) {
            dispatch(pushLocation(location));
        }
    }, [location]);

    return null;
};

export default Location;
